import { Injectable } from '@angular/core';

import { RuntimeSlideModel } from './models';

@Injectable({ providedIn: 'root' })
export class SlideScheduleService {
  public isEligible(slide: RuntimeSlideModel, now: number): boolean {
    return (slide.meta.startsAt === undefined || slide.meta.startsAt <= now)
      && (slide.meta.expiresAt === undefined || slide.meta.expiresAt > now);
  }
}
